import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Paragraph, View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity, ParagraphEntity, ReferenceField } from '@uncinc/react-drupal-core/types';

import HeroBuurtboerderij from '../../../../components/Heros/HeroBuurtboerderij';
import type { NodeRentalLocation } from '../../../../types/uncinc_profile/nodes';

interface NodeRentalLocationFullProps {
  entity: ImmutableEntity<NodeRentalLocation>;
}

const NodeRentalLocationFull: React.FC<NodeRentalLocationFullProps> = ({ entity }) => {
  const node = entity.toJS();
  const nid = node.nid[0].value;
  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const capacity = node.field_capacity[0].value;
  const paragraphs = node.field_paragraphs as ReferenceField<ParagraphEntity>[];
  const classNames = c('NodeRentalLocation', 'NodeRentalLocation--Full');

  return (
    <article itemType="http://schema.org/WebPage" className={classNames}>
      <HeroBuurtboerderij
        title={title}
        subtitle={capacity}
        body={body}
      />

      {paragraphs.length > 0 && (
        <div className="node--page--paragraphs-wrapper">
          {paragraphs.map((paragraph) => {
            const id = paragraph.target_id;
            const language = paragraph.entity?.langcode[0]?.value;

            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={Immutable.fromJS(paragraph.entity)}
              />
            );
          })}
        </div>
      )}

      {/* @TODO: Add rental webform */}

      <View
        id="rental_locations"
        display="related"
        args={[nid]}
      />
    </article>
  );
};

export default NodeRentalLocationFull;
